<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsZileDisponibilitate"
      :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
      :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
      :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false"
      @selection-changed="onSelectionChanged" @row-removing="onRowRemoving" class="border">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="5" :page-index="1" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="ZileDisponibilitate" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="600" :height="270">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid>
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem data-field="Cod" :editor-options="{ width: 560 }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem data-field="Valoare" :editor-options="{ width: 560 }" />
          </DxItem>
        </DxFormGrid>
      </DxEditing>
      <DxColumn data-field="Cod" />
      <DxColumn data-field="Valoare" />
    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="550" :height="270">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
          Adăugare</div>
      </template>
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addSaveButtonOptions" />
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addCancelButtonOptions" />
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem dataField="Cod" :isRequired="true">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem dataField="Valoare" :isRequired="true" />
          </DxItem>
        </DxForm>
      </div>
    </DxPopupAdd>
  </body>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import CrmZileDisponibilitate from '@/services/Comercial/CrmZileDisponibilitate';

export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
  },

  data() {
    return {
      dsZileDisponibilitate: {} as ODataStore,
      isModalVisible: false,
      formData: {
        Cod: '',
        Valoare: '',
      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",

      dataGridRef: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      addSaveButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSave();
        },
      },
      addCancelButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      customTitleTemplate() {
        return `
          <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:665px; color: white; 
          font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
            Editare
          </div>
        `;
      },
    };
  },
  methods: {
    createODataContext() {
      this.dsZileDisponibilitate = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_ZileDisponibilitate',
        key: 'ID',
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
          };
        },
      });
    },
    onSelectionChanged(e: any) {
      const selectedRow = e.selectedRowsData[0];
      this.$emit('selection-changed', selectedRow.ID);
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSave() {
      if (!this.formData.Cod || this.formData.Cod.trim() === '') {
        notify('Completați câmpul obligatoriu "Cod"!', 'error', 1000);
        return;
      }
      if (!this.formData.Cod || this.formData.Valoare.trim() === '') {
        notify('Completați câmpul obligatoriu "Valoare"!', 'error', 1000);
        return;
      }
      this.createODataContext();
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      console.log(this.formData);
      const body = this.formData;
      CrmZileDisponibilitate.save(body).then((response) => {
        this.isModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);
        this.formData = {
          Cod: '',
          Valoare: '',
        };
      }).catch((error) => {
        console.error(error);
        notify('Datele există deja!', 'error', 1000);
      });
    },
    onCancel() {
      this.isModalVisible = false;
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    onClick() {
      this.isModalVisible = true;
    },
    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate!', 'success', 1000)
    },
    onSaveEdit() {
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      this.dataGridRef?.instance?.saveEditData();
      savePromise.then((result) => {

      }).catch((error) => {
        console.error(error);


      });
    },
    onCancelEdit() {
      this.dataGridRef?.instance?.cancelEditData();
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGridRef?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
  },
  mounted() {
    this.createODataContext();
    this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>
<style scoped>
.border {
  border-radius: 8px;
}
</style>